import React, { useState } from "react";
import Logo from "../../assets/aboutlogo.png";
import WhatWeDo from "../../assets/WhatWeDo.webp";
import WhoWeAre from "../../assets/WhoWeAre.webp";
import { AiOutlineUser } from "react-icons/ai";
import styled from "styled-components";
import { AiOutlineDashboard } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { FiLogOut } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Dropdown, Row, Space } from "antd";
import { BorderBottomOutlined } from "@ant-design/icons";

const fontFamily =
  "'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'";

const StyledMenu = styled.div`
  background-color: transparent;
  color: #021d49;
  font-weight: 700;
  font-size: 1.3rem;
  display: flex;
  justify-content: center;
  gap: 25px;
  font-family: ${fontFamily};

  .menu-item:hover {
    background-color: transparent;
    color: #0c2650;
    cursor: pointer;
  }

  @media (max-width: 1150px) {
    font-size: 0.85rem;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100vw;
  background-color: #fff;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  font-family: ${fontFamily};
  font-weight: 700;
  padding-top: 80px;
  padding-bottom: 150px;
  padding-left: 50px;
  padding-right: 50px;
`;

const MenuItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 19px;
  width: 50%;
  font-family: ${fontFamily};
  font-weight: 700;
  line-height: 39px !important;
  margin-right: 100px;
`;

const MenuItem = styled.div`
  flex: 1 0 30%;
  margin-top: -15px;
  cursor: pointer;
  border-top: 1px solid #0c2650;
  a {
    text-decoration: none;
    color: #0c2650;
  }
  font-family: ${fontFamily};
  font-weight: 700;
  line-height: 39px !important;
`;

const MenuItemNew = styled.div`
  flex: 1 0 30%;
  margin-top: -15px;
  cursor: pointer;
  border-top: 1px solid #0c2650;
  border-bottom: 1px solid #0c2650;
  a {
    text-decoration: none;
    color: #0c2650;
  }
  font-family: ${fontFamily};
  font-weight: 700;
  line-height: 39px !important;
  decoration: none;
`;

const MenuItemCargo = styled.div`
  flex: 1 0 30%;
  margin-top: -15px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #0c2650;
  }
  font-family: ${fontFamily};
  font-weight: 700;
  line-height: 39px !important;
`;

const ImageContainer = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const DropdownMenuNew = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100vw;
  background-color: #fff;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  z-index: 1000;
  font-family: ${fontFamily};
  font-weight: 700;
  padding-top: 80px;
  padding-bottom: 150px;
  padding-left: 300px;
  padding-right: 200px;

  @media (min-width: 1024px) {
    margin-left: 90px;
    padding: 40px 30px 40px 20px;
  }
  @media (max-width: 1024px) {
    margin-left: 90px;
    padding: 40px 30px 40px 20px;
  }
`;

const ImageContainerNew = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const MenuItemContainerNew = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  width: 100%;
  font-family: ${fontFamily};
  font-weight: 700;
  line-height: 39px !important;
  margin-right: 100px;
  border-top: 1px solid grey;
  border-bottom: 1px solid grey;
  padding-top: 10px;
`;

const MenuItemNext = styled.div`
  flex-basis: 100%; /* Each item takes up the full width */
  margin-top: -15px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #0c2650;
  }

  font-family: ${fontFamily};
  font-weight: 700;
  line-height: 39px !important;
  margin-left: 15px;
  @media (max-width: 1024px) {
    margin-top: 0px;
    margin-left: 0px;
  }
`;

const MenuItemBold = styled.div`
  flex-basis: 100%; /* Each item takes up the full width */
  margin-top: -15px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #0c2650;
  }

  font-family: ${fontFamily};
  font-weight: 900;
  line-height: 39px !important;
`;

const Navbar = ({ userId }) => {
  const navigate = useNavigate();
  const [whatWeDoVisible, setWhatWeDoVisible] = useState(false);
  const [careersVisible, setCareersVisible] = useState(false);
  const [whoWeAreVisible, setWhoWeAreVisible] = useState(false);

  const handleMenuClick = (key) => {
    if (key === "1") {
      navigate(`/user/${userId}/dashboard`);
    } else if (key === "2") {
      navigate(`/user/${userId}/profile`);
    } else {
      localStorage.clear();
      navigate(`/`);
      window.location.reload();
    }
  };

  const handleMouseEnter = (menu) => {
    if (menu === "whatWeDo") {
      setWhatWeDoVisible(true);
      setCareersVisible(false);
      setWhoWeAreVisible(false);
    } else if (menu === "careers") {
      setCareersVisible(true);
      setWhatWeDoVisible(false);
      setWhoWeAreVisible(false);
    } else if (menu === "whoWeAre") {
      setWhoWeAreVisible(true);
      setWhatWeDoVisible(false);
      setCareersVisible(false);
    }
  };

  const handleMouseLeave = () => {
    setWhatWeDoVisible(false);
    setCareersVisible(false);
    setWhoWeAreVisible(false);
  };

  const handleItemClick = (path) => {
    navigate(path);
    handleMouseLeave();
  };

  const userDropdownItems = [
    { label: "Dashboard", key: "1", icon: <AiOutlineDashboard /> },
    { label: "Profile", key: "2", icon: <CgProfile /> },
    { label: "Log Out", key: "3", icon: <FiLogOut /> },
  ];

  const UserDropdownMenu = (
    <Dropdown
      menu={{
        items: userDropdownItems,
        onClick: (e) => handleMenuClick(e.key),
      }}>
      <Button
        style={{
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
        }}>
        <Space>
          <AiOutlineUser size={20} color="gray" />
        </Space>
      </Button>
    </Dropdown>
  );

  return (
    <>
      <Row
        align={"middle"}
        style={{
          backgroundColor: "transparent",
          width: "100%",
          padding: 0,
          margin: 0,
          lineHeight: 2,
        }}>
        <Col
          xs={0}
          sm={0}
          md={0}
          lg={24}
          xl={24}
          xxl={24}
          style={{ border: "0px solid green", height: "125%" }}>
          <Row
            style={{ backgroundColor: "transparent", border: "0px solid green" }}
            justify={"middle"}
            align={"middle"}>
            <Col span={24} style={{ border: "0px solid green" }}>
              <Row
                style={{
                  border: "0px solid green",
                  justifyContent: "space-around",
                  gap: "100px",
                  display: "flex",
                  alignItems: "center",
                }}>
                <Col
                  style={{ backgroundColor: "white", paddingInline: "1rem" }}>
                  <a href={"/"}>
                    <img src={Logo} alt="macworldlogisticlogo" height={50} />
                  </a>
                </Col>
                <Col
                  style={{
                    border: "0px solid green",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}>
                  <Row align={"middle"}>
                    <Col span={24}>
                      <StyledMenu>
                        <div className="menu-item">
                          <a style={{ color: "#021d49" }} href="/home">
                            HOME
                          </a>
                        </div>
                        <div
                          className="menu-item"
                          onMouseEnter={() => handleMouseEnter("whatWeDo")}
                          // onMouseLeave={handleMouseLeave}
                        >
                          WHAT WE DO
                        </div>
                        <div
                          className="menu-item"
                          onMouseEnter={() => handleMouseEnter("whoWeAre")}
                          // onMouseLeave={handleMouseLeave}
                        >
                          <a style={{ color: "#021d49" }}>
                            WHO WE ARE
                            </a>
                        </div>
                        <div className="menu-item">
                          <a style={{ color: "#021d49" }} href="/contact">
                            FIND US
                          </a>
                        </div>
                        <div
                          className="menu-item"
                          onMouseEnter={() => handleMouseEnter("careers")}
                          // onMouseLeave={handleMouseLeave}
                        >
                          CAREERS
                        </div>
                        {localStorage.getItem("access-token") ? (
                          <div className="menu-item">{UserDropdownMenu}</div>
                        ) : (
                          <div className="menu-item" style={{ color: "green" }}>
                            <a style={{ color: "#021d49" }} href="/login">
                              LOGIN
                            </a>
                          </div>
                        )}
                      </StyledMenu>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {whatWeDoVisible && (
        <DropdownMenu
          onMouseEnter={() => handleMouseEnter("whatWeDo")}
          onMouseLeave={handleMouseLeave}>
          <ImageContainer>
            <img
              src={WhatWeDo}
              alt="What We Do"
              style={{ height: "150px", width: "260px", paddingRight: "20px" }}
            />
          </ImageContainer>
          <MenuItemContainer>
            <MenuItem onClick={() => handleItemClick("/airfreight")} style={{}}>
              Air Freight
            </MenuItem>
            <MenuItem onClick={() => handleItemClick("/oceanfreight")}>
              Ocean Freight
            </MenuItem>
            <MenuItem onClick={() => handleItemClick("/landfreight")}>
              Land Freight
            </MenuItem>
            <MenuItemNew onClick={() => handleItemClick("/contract-logistic")}>
              Contract Logistics
            </MenuItemNew>
            <MenuItemNew
              onClick={() => handleItemClick("/warehousing-and-distribution")}>
              Warehousing & Distributions
            </MenuItemNew>
            <MenuItemNew onClick={() => handleItemClick("/relocation")}>
              Relocation
            </MenuItemNew>
            <MenuItemCargo onClick={() => handleItemClick("/projectcargo")}>
              Project Cargo
            </MenuItemCargo>
          </MenuItemContainer>
        </DropdownMenu>
      )}
      {careersVisible && (
        <DropdownMenu
          onMouseEnter={() => handleMouseEnter("careers")}
          onMouseLeave={handleMouseLeave}>
          <MenuItemContainer>
            <MenuItem onClick={() => handleItemClick("/career/findajob")}>
              Find a Job
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleItemClick("/career/findajob/candidateprofile")
              }>
              - My Candidate Profile
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleItemClick("/career/findajob/signupforalerts")
              }>
              - Sign up for Job Alerts
            </MenuItem>
            <MenuItem onClick={() => handleItemClick("/career/lifeatmwl")}>
              Life @ Mac World Logistic
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleItemClick("/career/lifeatmwl/talentsapproach")
              }>
              - MWL Talents Approach
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleItemClick("/career/lifeatmwl/diversityinclusion")
              }>
              - Diversity & Inclusion
            </MenuItem>
            <MenuItem
              onClick={() => handleItemClick("/career/leadershipmwl")}
              style={{ borderBotton: "1px solid #0C2650" }}>
              Leadership @ Mac World Logistic
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleItemClick("/career/leadershipmwl/leadingbusiness")
              }>
              - Leading Business
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleItemClick("/career/leadershipmwl/leadingteam")
              }>
              - Leading Team
            </MenuItem>
          </MenuItemContainer>
        </DropdownMenu>
      )}
      {whoWeAreVisible && (
        <DropdownMenuNew
          onMouseEnter={() => handleMouseEnter("whoWeAre")}
          onMouseLeave={handleMouseLeave}>
          <ImageContainer>
            <img
              src={WhatWeDo}
              alt="What We Do"
              style={{ height: "170px", width: "240px", paddingRight: "20px" }}
            />
          </ImageContainer>
          <MenuItemContainerNew>
            <MenuItemBold>About CEVA Logistics</MenuItemBold>
            <MenuItemNext>Our Vision &amp; Mission</MenuItemNext>
            <MenuItemNext>Our Values</MenuItemNext>
            <MenuItemNext>Our History</MenuItemNext>
            <Link
              style={{ color: "black", textDecoration: "none" }}
              to="/airfreight">
              <MenuItemNext>Facts &amp; Figures</MenuItemNext>
            </Link>
            <MenuItemNext>About Innovative</MenuItemNext>
            <MenuItemNext>
              <Link
                style={{ color: "black", textDecoration: "none" }}
                to="/about">
                About Us
              </Link>
            </MenuItemNext>
          </MenuItemContainerNew>

          {/* <MenuItemContainerNew>
            <MenuItemBold>About CEVA Logistics</MenuItemBold>
            <MenuItemNext>Our Vision & mission</MenuItemNext>
            <MenuItemNext>Our Values</MenuItemNext>
            <MenuItemNext>Our History</MenuItemNext>
            <MenuItemNext>Facts & Figures</MenuItemNext>
            <MenuItemNext>About Innovative</MenuItemNext>
          </MenuItemContainerNew>
          <MenuItemContainerNew>
            <MenuItemBold>About CEVA Logistics</MenuItemBold>
            <MenuItemNext>Our Vision & mission</MenuItemNext>
            <MenuItemNext>Our Values</MenuItemNext>
            <MenuItemNext>Our History</MenuItemNext>
            <MenuItemNext>Facts & Figures</MenuItemNext>
            <MenuItemNext>About Innovative</MenuItemNext>
          </MenuItemContainerNew> */}
        </DropdownMenuNew>
      )}
    </>
  );
};

export default Navbar;
